/**
 * Front-end interactivity for USPs block
 */

document.addEventListener( 'DOMContentLoaded', () => {
	const uspCards = document.querySelectorAll( '.wi-usp-card' );
	if ( 'IntersectionObserver' in window ) {
		const observer = new IntersectionObserver(
			( entries ) => {
				entries.forEach( ( entry ) => {
					if ( entry.isIntersecting ) {
						entry.target.classList.add( 'is-visible' );
					}
				} );
			},
			{ threshold: 0.15 }
		);

		uspCards.forEach( ( card ) => observer.observe( card ) );
	}
} );
